import { Link } from "react-router-dom";
import { Phone, ArrowUpRight } from "lucide-react";
import { COMPANY } from "../data/site";

export default function ContactCTA({
  title = "Behöver du hjälp med ett träd?",
  text = "Beskriv vad du behöver hjälp med så återkommer vi med nästa steg. Skicka gärna bild på trädet och berätta var det står, så blir det lättare att göra en första bedömning.",
}) {
  return (
    <section data-testid="contact-cta" className="section-pad bg-[#F7F5F0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-[#111812] text-white rounded-2xl overflow-hidden tf-grain relative">
          <div className="absolute inset-0 opacity-25 pointer-events-none">
            <img
              src="/images/hero.webp"
              alt=""
              loading="lazy"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#111812] via-[#111812]/90 to-[#111812]/30" />
          </div>

          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-10 p-8 sm:p-12 lg:p-16 items-center">
            <div className="lg:col-span-7">
              <span className="eyebrow !text-[#F2A57C]">Kontakt</span>
              <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight tracking-tight">
                {title}
              </h2>
              <p className="mt-5 text-[#D9DCD3] text-lg leading-relaxed max-w-2xl">
                {text}
              </p>
            </div>
            <div className="lg:col-span-5 flex flex-col gap-3 sm:flex-row lg:flex-col">
              <Link
                to="/kontakt#offert"
                data-testid="contact-cta-quote-button"
                className="inline-flex items-center justify-between gap-2 bg-[#D95D2E] hover:bg-[#B84B22] text-white font-semibold px-6 py-4 rounded-lg transition-colors text-lg"
              >
                Få offert
                <ArrowUpRight className="w-5 h-5" />
              </Link>
              <a
                href={`tel:${COMPANY.phoneE164}`}
                data-testid="contact-cta-phone-button"
                className="inline-flex items-center justify-between gap-2 border-2 border-white/70 hover:bg-white hover:text-[#111812] text-white font-semibold px-6 py-4 rounded-lg transition-colors text-lg"
              >
                <span className="inline-flex items-center gap-2">
                  <Phone className="w-5 h-5" />
                  Ring {COMPANY.phone}
                </span>
                <ArrowUpRight className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
